export default "__VITE_ASSET__c3556e6c__"